module.exports = __webpack_public_path__ + "static/img/ilu-agende.9e6816a.jpg";